import React, { useCallback } from "react";

import Form from "antd/es/form";
import { useIntl } from "react-intl";

import { NumberField } from "@mapmycustomers/ui";

import TextWithInfo from "@app/component/typography/TextWithInfo";
import useAnalytics from "@app/util/contexts/useAnalytics";

import styles from "./FormItems.module.scss";

const CheckInRadius = () => {
  const intl = useIntl();
  const analyticIssuer = useAnalytics();

  const handleChange = useCallback(
    (meters) => {
      analyticIssuer.clicked(["Check-In Radius"], { meters });
    },
    [analyticIssuer]
  );

  return (
    <div className={styles.formItemContainer}>
      <TextWithInfo
        className={styles.fieldTitle}
        info={intl.formatMessage({
          id: "settings.organizationDetails.checkInRadius.infoText",
          defaultMessage:
            "How close does a user need to be to a Company or Person in order for a Check-In to be considered verified?",
          description: "Activity check in Radius info text of settings organization details",
        })}
      >
        {intl.formatMessage({
          id: "settings.organizationDetails.checkInRadius.label",
          defaultMessage: "Check-In Radius",
          description: "Activity check in radius label of settings organization details",
        })}
      </TextWithInfo>
      <div className={styles.checkInRadius}>
        <Form.Item name="checkInRadius">
          <NumberField className={styles.numberField} onChange={handleChange} step={25} />
        </Form.Item>
        <span className={styles.text}>
          {intl.formatMessage({
            id: "settings.organizationDetails.checkInRadius.distance.suffix",
            defaultMessage: "METERS",
            description: "Meters unit name in checkIn radius",
          })}
        </span>
      </div>
    </div>
  );
};

export default CheckInRadius;
